<template>
  <div class="grafik-tier-source mb-1">
    <div class="row">
      <div class="col-md-12 px-gap">
        <div class="card card-default shade">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Grafik Tingkat Media Online</h4>
                  <p class="small hint-text">Grafik per Tingkat Media Online</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <bar-chart-component :source="source" :dataset="data_news.series" :yLabel="data_news.yLabel" :is_clickable="false"
                  barchart_id="barchart-tier-news" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-4 px-gap">
        <div class="card card-default shade">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Grafik Tier Media Cetak</h4>
                  <p class="small hint-text">Grafik per Tier Media Cetak</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <bar-chart-component :dataset="data_media_cetak.series" :yLabel="data_media_cetak.yLabel"
                  :is_clickable="false" barchart_id="barchart-tier-media-cetak" />
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="col-md-4 px-gap">
        <div class="card card-default shade">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Grafik Tier Media TV</h4>
                  <p class="small hint-text">Grafik per Tier Media TV</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <bar-chart-component :dataset="data_media_tv.series" :yLabel="data_media_tv.yLabel" :is_clickable="false"
                  barchart_id="barchart-tier-media-tv" />
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import bar_chart_highchart from "@/views/components/chart/bar_chart_highchart.vue";

export default {
  name: "medkon_tier_source",
  components: {
    "bar-chart-component": bar_chart_highchart,
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {
      source: this.data.source,
      data_news: {
        series: this.data.news.series,
        yLabel: "Frekuensi",
      },
      data_media_cetak: {
        series: this.data.media_cetak.series,
        yLabel: "Frekuensi",
      },
      data_media_tv: {
        series: this.data.media_tv.series,
        yLabel: "Frekuensi",
      },
    };
  },
};
</script>